import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useTestingStore } from "@/stores/testingStore";

/**
 * Thin selector over testingStore's org-config CONSENT slice (mirrors useHealRun). The apply → re-run →
 * verdict loop lives in the store (module scope, survives tab navigation); this binds queryClient for the
 * actions so callers pass only (planId, changeId).
 */
export function useOrgConfig() {
	const queryClient = useQueryClient();
	const deciding = useTestingStore((s) => s.orgConfigDeciding);
	const applyResult = useTestingStore((s) => s.orgConfigApplyResult);
	const verdict = useTestingStore((s) => s.orgConfigVerdict);
	const acceptAction = useTestingStore((s) => s.acceptOrgConfig);
	const rejectAction = useTestingStore((s) => s.rejectOrgConfig);
	const revertAction = useTestingStore((s) => s.revertOrgConfig);
	const reset = useTestingStore((s) => s.orgConfigReset);

	const accept = useCallback(
		(planId: string, changeId: string) => acceptAction(planId, changeId, queryClient),
		[acceptAction, queryClient],
	);
	const reject = useCallback(
		(planId: string, changeId: string) => rejectAction(planId, changeId),
		[rejectAction],
	);
	const revert = useCallback(
		(planId: string, changeId: string) => revertAction(planId, changeId),
		[revertAction],
	);

	return { deciding, applyResult, verdict, accept, reject, revert, reset };
}
